import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CvIcon: React.FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 -3 24 24" {...props}>
      <path
        d="M18.6,0.4l0,0.3c3,0,1.8,3,1.1,5l-2.5,6.9l-3.7-10c0-0.1-0.5-1.9,1.2-1.9l0-0.3L9.2,0.4C8.6,0.3,8,0.3,7.3,0.3
C3,0.3,0.2,3.1,0.2,7.8c0,4.7,2.9,7.5,7.2,7.5c2.2,0,3.4-0.3,5-1.3L12,10.8l-0.3,0C11.5,14,9,15.1,7.3,15.1c-2.1,0-4.5-0.9-4.5-7.3
c0-6.3,2.4-7.1,4.5-7.3c2.5-0.2,3.8,1.7,4.3,2.8c0.1,0.2,0.2,0.5,0.3,0.8c0,0,0,0,0,0l0,0c0.9,2.4,2.6,6.9,4.3,11l0.3,0L20,5.7
c1.9-5,2.4-5,3.7-5l0-0.3L18.6,0.4z"
      />
    </SvgIcon>
  );
};
